import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemHeaderValue
} from "../../report-design-item";

@Pipe({
  name: "asHeaderValue",
  standalone: false
})
export class ReportItemConfigAsHeaderValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemHeaderValue {
    return <ReportDesignItemHeaderValue>value;
  }
}
